import SEOHEAD from "@components/SEOHEAD";
import FloatScrollButton from "@components/ui/FloatScrollButton";
import gate from "gate";
import React, { FC } from "react";
import { useQuery } from "react-query";
import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const About: FC = () => {
  const { data, isLoading } = useQuery("about-slider", () => gate.about(), {
    select: (data: any) => data?.data,
  });
  const pagination = {
    clickable: true,
    renderBullet: function (index: number, className: string) {
      return (
        '<div  class="' + className + " xl:!inline-block !hidden " + '"></div>'
      );
    },
  };

  return (
    <>
      <div>
        <SEOHEAD
          {...{
            canonical: "https://dadbanan.com/about-us/درباره-دادبانان",
            title: "درباره دادبانان | مؤسسه دادبانان",
            keyword: ["دادبانان"],
            seoDescription:
              " مؤسسه حقوقی دادبانان در راستای ارائه خدمات حقوقی مبتنی بر تخصص گرایی در تلاش است با استفاده از نیروی انسانی متخصص در هر گرایش و با همکاری فارغ التحصیلان دانشگاههای معتبر کشور، گامی مهم در جهت ایجاد یک مؤسسه حقوقی مبتنی بر دانش و تجربه برداشته باشد.",
          }}
        />
        <div
          className="flex h-[42px] w-full items-center bg-cover px-10 md:h-20 md:px-[13.5%] md:text-2xl xl:h-44"
          style={{ backgroundImage: `url('/images/bg-about.png')` }}
        >
          <h1 className="text-[15px] text-white md:text-2xl 2xl:text-[40px]">
            درباره دادبانان دانا
          </h1>
        </div>
        <div className="px-10 py-6 md:py-7 md:px-[13.5%] xl:py-[60px]">
          <h3 className="mb-[30px] text-sm font-bold md:text-lg xl:text-xl">
            داستان دادبانان
          </h3>
          <p className="text-justify text-xs md:text-base xl:text-lg">
            گروه حقوقی دادبانان در سال ۱۳۸۸، با مدیریت عاملی دکتر فرهاد بیات
            مدرس دانشگاه تهران و وکیل پایه یک دادگستری، به عنوان یکی
            از مؤسسات پیشرو در جذب، به کارگیری و سازماندهی نخبگان رشته‌ی حقوق 
            با هدف ارائه‌ی خدمات حقوقی، تشکیل و راه‌اندازی گردید. این مؤسسه در
            راستای ارائه‌ی خدمات حقوقی مبتنی بر تخصص‌گرایی و استفاده از نیروی
            انسانی متخصص در هر گرایش از دانش حقوقی، در تلاش است تا با همکاری
            فارغ التحصیلان دانشگاه‌های معتبر کشور، گامی مهم در جهت ایجاد یک
            مؤسسه‌ی حقوقی مبتنی بر دانش و تجربه برداشته باشد.
          </p>
        </div>
        <div className="w-full">
          <h2 className="mb-10 hidden text-center text-[40px] md:block">
            اهداف دادبانان
          </h2>
          <div className="custom-bullet w-full">
            <Swiper
              spaceBetween={50}
              pagination={pagination}
              slidesPerView={1}
              modules={[Autoplay, Pagination]}
            >
              {data?.sliders?.map((slide: any) => (
                <SwiperSlide key={JSON.stringify(slide?.image)}>
                  <div className="relative h-[152] text-white md:h-[255px] xl:h-[353px]">
                    <img
                      loading="lazy"
                      src={slide?.image ?? "images/dadbanan-education.png"}
                      alt={slide?.title}
                      className="h-[152px] w-full md:h-full"
                    />
                    <div
                      className="absolute top-1/2 left-1/2 flex h-[75%] w-10/12 -translate-x-1/2 -translate-y-1/2 flex-col justify-evenly rounded-md p-6 text-white md:w-[73%] md:p-[30px] lg:translate-x-0 lg:px-8 lg:py-10 xl:right-[13.5%] xl:h-auto xl:w-[37%]"
                      style={{
                        background:
                          slide?.color ??
                          "linear-gradient(270deg, rgba(54, 100, 148, 0.8) 0%, rgba(4, 128, 212, 0.8) 50%, rgba(39, 178, 188, 0.8) 100%)",
                      }}
                    >
                      <div className="mb-3 text-sm md:text-lg xl:text-[22px]">
                        {slide?.title}
                      </div>
                      <p className="text-xs md:text-base xl:text-lg">
                        {" "}
                        {slide?.description}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div className="px-10 py-[30px] md:py-[60px] md:px-[13.5%]">
          <h3 className="mb-[30px] text-sm font-bold md:text-lg xl:text-xl">
            دپارتمان‌های مؤسسه:
          </h3>
          <h4 className="text-back-450 mb-[30px] text-xs font-bold md:text-base xl:text-lg">
            مؤسسه دارای چهار دپارتمان اصلی به شرح زیر است:
          </h4>
          <div className="my-5">
            <h5 className="text-justify text-xs font-bold md:text-base xl:text-lg">
              دپارتمان آموزش:
            </h5>
            <p className="text-justify text-xs md:text-base xl:text-lg">
              یکی از مهمترین خلاءهای نظام آموزش کشور، آموزش کاربردی مسائل حقوقی
              پیرامون کسب و کار است. مؤسسه‌ی حقوقی دادبانان در راستای حل این
              مشکل با همکاری دانشکده ی کارآفرینی و پارک علم و فناوری دانشگاه
              تهران، مبادرت به برگزاری دوره‌ی جامع حقوق کسب و کار نموده است،
              دوره‌های کاملاً کاربردی و مبتنی بر تجربه‌های عملی که بر اساس
              سرفصل‌های کتاب «آنچه مشاور حقوقی باید بداند» تدریس می‌شود. همچنین
              در کنار کارگاه جامع، کارگاه‌های مهارت‌افزایی به صورت متغیر و با
              توجه به نیازهای روز تعریف و برگزار می‌گردد.
            </p>
          </div>
          <div className="my-5">
            <h5 className="text-justify text-xs font-bold md:text-base xl:text-lg">
              دپارتمان انتشارات و پژوهش‌های حقوقی:
            </h5>
            <p className="text-justify text-xs md:text-base xl:text-lg">
              دادبانان دانا واحد انتشاراتی مؤسسه‌ی حقوقی دادبانان می‌باشد که قصد
              دارد کتب ارزشمند کاربردی در حوزه‌ی حقوق کسب و کار را معرفی و ارائه
              نماید. همچنین دانش‌پذیران می‌توانند با پیش مطالعه‌ی کتب مرتبط با
              کارگاه‌ها، با آمادگی بیشتر در کارگاه‌های مؤسسه شرکت کنند که فهم و
              درک عملی و دقیق‌تری از مطالب داشته باشند .{" "}
            </p>
          </div>
          <div className="my-5">
            <h5 className="text-justify text-xs font-bold md:text-base xl:text-lg">
              دپارتمان وکالت دعاوی و مشاوره حقوقی:
            </h5>
            <p className="text-justify text-xs md:text-base xl:text-lg">
              یکی از مهمترین خدمات حقوقی، ارائه‌ی مشاوره حقوقی با هدف پیشگیری از
              بروز اختلافات است. از آن جایی که طرح دعوی در دادگاه مستلزم صرف
              هزینه‌ی بالا و از دست دادن زمان است، دریافت مشاوره حقوقی میتواند
              نقش مؤثری در موفقیت یک بنگاه اقتصادی داشته باشد. حتی پس از بروز
              اختلاف نیز، مشاوره حقوقی میتواند به حل اختلاف و حفظ حقوق اشخاص کمک
              نماید. تنظیم قرارداد و صورت‌ جلسات استاندارد نیز میتواند در
              پیشگیری از دعوی یا حل آن نقش به سزایی داشته باشد .{" "}
            </p>
          </div>
          <div className="my-5">
            <h5 className="text-justify text-xs font-bold md:text-base xl:text-lg">
              دپارتمان داوری:
            </h5>
            <p className="text-justify text-xs md:text-base xl:text-lg">
              امروزه یکی از شیوه های مهم حل و فصل اختلاف، داوری است, همینطور به
              دلیل ساده تر بودن تشریفات رسیدگی داوری، آزادی طرفین اختلاف در
              انتخاب داور مورد اعتماد خود، کم هزینه تر بودن داوری، انتخاب داور
              دارای صلاحیت تخصصی در موضوع مورد اختلاف و سایر دلایل مشابه تمایل
              بیشتری به حل اختلافات از طریق داوری به وجود آمده است. به عبارت
              دیگر می توان گفت این روش حل اختلاف با طبع اختلافات و دعاوی حقوق
              کسب و کار هماهنگی بیشتری دارد. مؤسسه حقوقی دادبانان نیز در همین
              راستا، یکی از بخشهای تخصصی اصلی خود را به داوری اختصاص داده است.
            </p>
          </div>
        </div>
      </div>
      <FloatScrollButton />
    </>
  );
};

export default About;
